import { Router, Event } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RouteService {

    constructor(private router: Router) {
    }

    public get url(): string {
        return this.router.url;
    }


    public get events(): Observable<Event> {
        return this.router.events;
    }



    public gotoNewProfile() {
        this.router.navigate(['/profilenew']);
    }
    public gotoProfileSetting() {
        this.router.navigate(['/profile']);
    }

    public goToBranch(branchId: number) {
        this.router.navigate(['/branch-profile/', branchId]);
    }

    public goToProblemDetaileFront(problemid: number, golrizCode?: string | null) {
        this.router.navigate(['/problemdetails', { problemid: problemid, golrizCode: golrizCode }]);
    }

    public goToSuggestions(mightyServeId: number) {
        this.router.navigate(['/suggestions'], { queryParams: { id: mightyServeId } });
    }

    public navigateByUrl(url: string) {
        this.router.navigateByUrl(url);
    }

    /**
     * name
     */
    public goToRegisterPerson() {
        this.router.navigate(['/register/person']);
    }

    public gotoHome() {
        this.router.navigate(['/home']);
    }

    public gotoError() {
        this.router.navigate(['/session/access-error']);
    }

}